import { jwtDecode } from 'jwt-decode'

const TOKEN_KEY = 'jwt_token'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function getTokenPayload() {
  const token = getToken()
  if (!token) return null

  try {
    return jwtDecode(token)
  } catch (e) {
    return null
  }
}

export function isTokenValid() {
  const payload = getTokenPayload()
  if (!payload || !payload.exp) return false

  const now = Date.now() / 1000 // en segundos
  return payload.exp > now
}

export function getCurrentUser() {
  const payload = getTokenPayload()
  return payload ? payload.user || payload.sub || payload.email : null
}

export function logout() {
  removeToken()
  window.location.href = '/#/'
}
export function isAdminGrupo() {
  const payload = getTokenPayload()
  return payload?.adminGrupo === 'true'
}

export function isAdminAgentes() {
  const payload = getTokenPayload()
  return payload?.adminAgentes === 'true'
}

export function isAdminForaneo() {
  const payload = getTokenPayload()
  return payload?.adminForaneos === 'true'
}

export function isSuperAdmin() {
  const payload = getTokenPayload()
  //console.log(payload)
  return payload?.superAdmin === 'true'
}

export function isAnyAdmin() {
  const payload = getTokenPayload()
  return (
    payload?.adminGrupo === true ||
    payload?.adminAgentes === true ||
    payload?.adminForaneos === true ||
    payload?.superAdmin === true
  )
}

export function setTieneFlotillas(value) {
  localStorage.setItem('tiene_flotillas', value ? 'true' : 'false')
}

export function getTieneFlotillas() {
  return localStorage.getItem('tiene_flotillas') === 'true'
}

export default {
  getToken,
  setToken,
  removeToken,
  getTokenPayload,
  isTokenValid,
  getCurrentUser,
  logout,
  setTieneFlotillas,
  getTieneFlotillas
}
